import { render, staticRenderFns } from "./UtilityMenu.vue?vue&type=template&id=a064add6&scoped=true"
import script from "./UtilityMenu.vue?vue&type=script&lang=js"
export * from "./UtilityMenu.vue?vue&type=script&lang=js"
import style0 from "./UtilityMenu.vue?vue&type=style&index=0&id=a064add6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a064add6",
  null
  
)

export default component.exports